module.exports = __webpack_public_path__ + "img/banner1.e4ee559d.png";